import { render, staticRenderFns } from "./ProgrammingLanguages.vue?vue&type=template&id=13b48ec0&scoped=true"
import script from "./ProgrammingLanguages.vue?vue&type=script&lang=js"
export * from "./ProgrammingLanguages.vue?vue&type=script&lang=js"
import style0 from "./ProgrammingLanguages.vue?vue&type=style&index=0&id=13b48ec0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b48ec0",
  null
  
)

export default component.exports